import { SelectProps } from 'antd';
import ProtectedResource from 'components/RoleBasedAccessControl/ProtectedResource';
import SelectComponent from 'components/Select';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setUserCountry } from 'store/auth';
import { selectUserCountry } from 'store/auth/selectors';
import { SUPPORTED_COUNTRIES } from 'utils/constants';

interface RBCountryFilterProps extends SelectProps {
  selectedCountry: string;
  onChange: (value: string) => void;
  label?: string;
}

const RBCountryFilter = (props: RBCountryFilterProps) => {
  const { selectedCountry, onChange, label, ...rest } = props;
  const userCountry = useSelector(selectUserCountry);
  const { t } = useTranslation();

  const renderComponent = (extraProps?: SelectProps) => {
    return (
      <SelectComponent
        label={label ?? t('common.filters.country')}
        options={SUPPORTED_COUNTRIES}
        placeholder={t('common.filters.countryPlaceholder')}
        value={selectedCountry}
        onChange={onChange}
        {...extraProps}
        {...rest}
      />
    );
  };

  return (
    <ProtectedResource
      permission={'country:read'}
      fallback={renderComponent({
        disabled: true,
        onChange: () => {},
        value: userCountry,
        options: [],
      })}
    >
      {renderComponent()}
    </ProtectedResource>
  );
};

export const useRoleBasedCountryFilter = () => {
  const userCountry = useSelector(selectUserCountry);
  const dispatch = useDispatch();

  const setCountry = useCallback((country: string) => {
    dispatch(setUserCountry(country));
  }, []);

  return [userCountry, setCountry] as const;
};

export default RBCountryFilter;
